






import { Vue, Component, Prop } from 'vue-property-decorator';

import { PasoCrud } from '@/reusable/Mantenedor/mantenedorUtils';

@Component({})
export default class CrudStepperItems extends Vue {
  @Prop({ required: true }) paso: PasoCrud;
}
